import { Box } from "@chakra-ui/react";
import { RiskFactor, riskFactorColors } from "@keita/lanepatrol-sdk";
import { MapColoringLegendItem } from "./MapColoringLegendItem";
import { tRiskFactor } from "../../../../coding/utils/score-utils";

const crashTypes = Object.values(RiskFactor).reverse();

export const MapColoringScore: React.FC = () => {
  return (
    <Box>
      {crashTypes.map((crashType) => (
        <MapColoringLegendItem key={crashType} color={riskFactorColors[crashType]}>
          {tRiskFactor(crashType)}
        </MapColoringLegendItem>
      ))}
    </Box>
  );
};
